<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.haberler.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.haberler.arsiv.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="margin-bottom-10 animated fadeInUp">
            <el-radio-group v-model="dil" size="mini" v-on:change="dilChange($event)">
                <el-radio-button label="tr"><i class="flag-icon flag-icon-tr"></i></el-radio-button>
                <el-radio-button label="en"><i class="flag-icon flag-icon-gb"></i></el-radio-button>
            </el-radio-group>
        </div>
        <div class="card-base kaldirilmis animated fadeInUp delay-1s">Arşivlenmiş Haberler</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp delay-1s">
            <el-table
                    :data="haberlerListArsiv"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="50">
                </el-table-column>
                <!--<el-table-column-->
                        <!--:filters="filters"-->
                        <!--:filter-method="filterTag"-->
                        <!--filter-placement="bottom-end"-->
                        <!--prop="kategoriAdi"-->
                        <!--label="Kategori"-->
                        <!--width="auto">-->
                    <!--<template slot-scope="scope">-->
                        <!--<el-tag-->
                                <!--:type="kategoriType(scope.row)"-->
                                <!--disable-transitions>{{scope.row.kategoriAdi}}-->
                        <!--</el-tag>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <!--<router-link :to="{ path:'/haberler/guncelleme?haberKodu='+scope.row.haberKodu}">-->
                            <!--<el-tooltip :content='$t("src.views.apps.haberler.arsiv.duzenle")' :open-delay="500"-->
                                        <!--placement="bottom">-->
                                <!--<el-button-->
                                        <!--type="warning"-->
                                        <!--size="mini"-->
                                        <!--icon="el-icon-edit">-->
                                <!--</el-button>-->
                            <!--</el-tooltip>-->
                        <!--</router-link>-->
                        &nbsp;
                        <el-tooltip :content='$t("src.views.apps.haberler.arsiv.ekle")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    @click="haberDurumChange(scope.row,scope.$index,haberlerListArsiv,1);"
                                    size="mini"
                                    type="primary"
                                    icon="mdi mdi-plus">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import haberlerService from '../../../WSProvider/HaberService'
    import status from '../../../notification'


    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: "HaberArsiv",
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataSidas")) {
                userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
                if (userDataSidas["tur"]) {
                    if (userDataSidas["tur"] === '1' || userDataSidas["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.getHaberArsivList();
            }
        },
        data() {
            return {
                dil: 'tr',
                page: 0,
                sizes: 10,
                postPage: '',
                total: null,

                selection: '',
                selectionIndex: '',
                haberlerListArsiv: [],
                kategoriListe: [],
                haberlerForm: {
                    kategori: ''
                },
                rulesHaberler: {
                    kategori: [{
                        required: true,
                        message: "Lütfen Kategori Seçiniz",
                        trigger: 'blur'
                    }]
                },

                filters: [
                    {text: 'Haberler', value: 'Haberler'},
                    // {text: 'Etkinlik', value: 'Etkinlik'},
                    // {text: 'Duyuru', value: 'Duyuru'},
                    // {text: 'Basında Biz', value: 'Basında Biz'}
                ]
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getHaberArsivList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getHaberArsivList();
            },
            filterTag(value, row) {
                return row.kategoriAdi === value;
            },
            dilChange(event) {
                this.dil = event;
                this.getHaberArsivList();
            },
            kategoriType(scope) {
                switch (scope.kategori) {
                    case '1' :
                        return 'primary';
                    case '2' :
                        return 'success';
                    case '3' :
                        return 'warning';
                    case '4' :
                        return 'danger';
                }
            },
            getHaberArsivList() {
                haberlerService.haberListDetay(0, this.postPage, this.sizes, 2,this.dil).then((response) => {
                    if (response.status === 200) {
                        this.haberlerListArsiv = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            haberDurumChange(selection, index, list, durum) {
                haberlerService.haberDurumGuncelle(selection.haberKodu, durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Haber başarıyla eklendi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this);

                    }
                })
            },
        }
    }
</script>


<style lang="scss" scoped>
    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px;
        margin-top: 10px;
    }

    .el-pagination {
        margin-top: 20px;
        float: right;
    }

</style>